module.exports = __webpack_public_path__ + "static/media/effect_fantastic.02f8fee9.png";